module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ded-f"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_c('em', [_vm._v("To Julie Klassen and Michelle Griep. You are both shining examples of what friendship should be.")])])]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_c('p', {
    staticClass: "ded1"
  }, [_c('em', [_vm._v("To all the members of the Inspirational Regency Readers group on Facebook. You are so appreciated!")])])]), _c('p', {
    staticClass: "ded1"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_c('em', [_vm._v("And to Peter, always, with my love.")])]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eca2a91a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/006_Dedication.vue
// module id = 72
// module chunks = 0